// Vendor libraries
import { inject } from '@angular/core';
// Services
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
// Directives
import { FolderableBase } from 'FoldersApp/directives/folderable-base.directive';
import * as i0 from "@angular/core";
/**
 * Base class for a component that represents a non-folder item that can be in a folder.
 */
export class ContentItemBase extends FolderableBase {
    constructor() {
        super(...arguments);
        this.bulkActionSelectionService = inject(BulkActionSelectionService);
    }
    get relativePositionedElemId() {
        return `list-item-dropdown-${this.folderable.resourceType}-${this.folderable.item.id}`;
    }
    get itemUrl() {
        return null;
    }
    get itemSelectionEnabled() {
        return false;
    }
    openInNewTab() {
        if (!this.itemUrl)
            return;
        // eslint-disable-next-line no-unused-expressions
        window.open(this.itemUrl, '_blank')?.focus();
    }
}
ContentItemBase.ɵfac = /*@__PURE__*/ (() => { let ɵContentItemBase_BaseFactory; return function ContentItemBase_Factory(__ngFactoryType__) { return (ɵContentItemBase_BaseFactory || (ɵContentItemBase_BaseFactory = i0.ɵɵgetInheritedFactory(ContentItemBase)))(__ngFactoryType__ || ContentItemBase); }; })();
ContentItemBase.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ContentItemBase, inputs: { folderable: "folderable", ancestorInfo: "ancestorInfo" }, features: [i0.ɵɵInheritDefinitionFeature] });
